// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-Actions-styles___actionButtonsContainer--iaCE7 {
  display: flex;
  justify-content: flex-end; 
  gap: 12px; 
  padding: 16px 0;
}

.components-Actions-styles___actionButtonBlue--D5OmU {
  border: 1px solid #318afb;
  border-radius: 6px;
  font-size: 17px;
  color: #318afb;
  letter-spacing: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  width: 185px;
  margin-right: 16px;
  cursor: pointer;
}

.components-Actions-styles___actionButtonBlue--D5OmU:hover {
    background: #318afb;
    color: white;
  }

.components-Actions-styles___actionButtonRed--iXggr {
  border: 1px solid rgb(252, 59, 96);
  border-radius: 6px;
  font-size: 17px;
  color: rgb(252, 59, 96);
  letter-spacing: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  width: 185px;
  margin-right: 16px;
  cursor: pointer;
}

.components-Actions-styles___actionButtonRed--iXggr:hover {
    background: rgb(252, 59, 96);
    color: white;
  }

.components-Actions-styles___actionButtonDisabled--DLyIu {
  border: 1px solid #d3d3d3;
  border-radius: 6px;
  font-size: 17px;
  color: #d3d3d3;
  letter-spacing: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 52px;
  width: 185px;
  margin-right: 16px;
  cursor: not-allowed;
  background: #f5f5f5;
}
`, "",{"version":3,"sources":["webpack://./components/Actions/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AAKjB;;AAJE;IACE,mBAAmB;IACnB,YAAY;EACd;;AAGF;EACE,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AAKjB;;AAJE;IACE,4BAA4B;IAC5B,YAAY;EACd;;AAGF;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".actionButtonsContainer {\n  display: flex;\n  justify-content: flex-end; \n  gap: 12px; \n  padding: 16px 0;\n}\n\n.actionButtonBlue {\n  border: 1px solid #318afb;\n  border-radius: 6px;\n  font-size: 17px;\n  color: #318afb;\n  letter-spacing: 0;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 52px;\n  width: 185px;\n  margin-right: 16px;\n  cursor: pointer;\n  &:hover {\n    background: #318afb;\n    color: white;\n  }\n}\n\n.actionButtonRed {\n  border: 1px solid rgb(252, 59, 96);\n  border-radius: 6px;\n  font-size: 17px;\n  color: rgb(252, 59, 96);\n  letter-spacing: 0;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 52px;\n  width: 185px;\n  margin-right: 16px;\n  cursor: pointer;\n  &:hover {\n    background: rgb(252, 59, 96);\n    color: white;\n  }\n}\n\n.actionButtonDisabled {\n  border: 1px solid #d3d3d3;\n  border-radius: 6px;\n  font-size: 17px;\n  color: #d3d3d3;\n  letter-spacing: 0;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 52px;\n  width: 185px;\n  margin-right: 16px;\n  cursor: not-allowed;\n  background: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionButtonsContainer": `components-Actions-styles___actionButtonsContainer--iaCE7`,
	"actionButtonBlue": `components-Actions-styles___actionButtonBlue--D5OmU`,
	"actionButtonRed": `components-Actions-styles___actionButtonRed--iXggr`,
	"actionButtonDisabled": `components-Actions-styles___actionButtonDisabled--DLyIu`
};
module.exports = ___CSS_LOADER_EXPORT___;
